<template>
  <component
    :is="widgetComponent"
    v-if="widgetComponent"
    v-bind="$attrs"
    :endpoint="endpoint"
    :hidden-ride-types="hiddenRideTypes"
    :selected-tab="selectedTab"
    :stripe-key="stripeKey"
  />
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      hiddenRideTypes: ['transfer', 'delivery'],
      selectedTab: 'cityTaxi',
    }
  },

  computed: {
    widgetComponent() {
      if (!this.$settings._loaded) {
        return null
      }

      if (this.$settings.cabinet_uses_new_widget) {
        return () => import('./BookingWidgetModern.vue')
      }

      return () => import('./BookingWidgetLegacy.vue')
    },

    endpoint() {
      const { VUE_APP_API_LOCATION } = process.env
      return VUE_APP_API_LOCATION.trimEnd('/')
    },

    stripeKey() {
      return this.$settings.stripe_key ?? process.env.VUE_APP_STRIPE_KEY
    },
  },
}
</script>
